// extracted by mini-css-extract-plugin
export default {"component":"Checkbox_component__+jdIo","disabled":"Checkbox_disabled__WpdNl","checked":"Checkbox_checked__WhOzV"};